<form [formGroup]="axisForm">
    <mat-form-field>
        <mat-select placeholder="{{'SELECT_AXIS_INCLINO'|translate}}" formControlName="inclinoAxes" [disabled]="!editable"
                    (selectionChange)="setAxisForm()" [value]="this.deviceParamLirisV3.inclinoAxes">
            <mat-option [value]="0">{{'AXIS'|translate}} X</mat-option>
            <mat-option [value]="1">{{'AXIS'|translate}} Y</mat-option>
            <mat-option [value]="2">{{'AXIS'|translate}} X &amp; Y</mat-option>
        </mat-select>
    </mat-form-field>
</form>

